import type { TcsRecommendationDTO } from "../models/TaxDTOs";
import type { TcsRecommendationEntity } from "../../domain/entities/TcsRecommendationEntity";

export function mapTcsRecommendationDTOToEntity(
  dto: TcsRecommendationDTO
): TcsRecommendationEntity {
  const confidence =
    typeof dto.confidence === "number"
      ? dto.confidence
      : typeof dto.confidence === "string"
        ? parseFloat(dto.confidence) || 0
        : 0;
  const tcsRate =
    dto.tcs_rate != null
      ? typeof dto.tcs_rate === "number"
        ? dto.tcs_rate
        : parseFloat(String(dto.tcs_rate)) || null
      : null;

  return {
    match_status:
      dto.match_status === "matched" ||
      dto.match_status === "no_match" ||
      dto.match_status === "unresolved"
        ? dto.match_status
        : "unresolved",
    ai_reasoning: dto.ai_reasoning ?? null,
    confidence: Number.isFinite(confidence) ? confidence : 0,
    matched_tax_name: dto.matched_tax_name ?? null,
    tcs_rate: tcsRate,
  };
}
